import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import { TYPE_LABELS } from "@/constants/media";

interface MediaCardProps {
  item: MediaItem;
  rank?: number;
  showViews?: boolean;
}

export default function MediaCard({ item, rank, showViews }: MediaCardProps) {
  return (
    <Link to={`/detail/${item.id}`} className="group block cursor-pointer animate-fade-up">
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-secondary-100">
        <img
          src={item.cover}
          alt={`${item.title} 影视封面`}
          title={`${item.title} - 星空传媒影视内容`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 rounded-md bg-primary-600/90 px-2 py-0.5 text-[11px] font-medium text-white backdrop-blur-sm">
          {TYPE_LABELS[item.type]}
        </span>
        <span className="absolute top-2 right-2 flex items-center gap-0.5 rounded-md bg-black/55 px-1.5 py-0.5 text-[11px] font-semibold text-accent-300 backdrop-blur-sm">
          <i className="ri-star-fill text-[10px]"></i>
          {item.rating.toFixed(1)}
        </span>
        {rank && (
          <span className="absolute bottom-0 left-0 flex h-9 w-9 items-center justify-center rounded-tr-lg bg-accent-500 font-heading text-sm font-bold text-white">
            {rank}
          </span>
        )}
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 translate-y-2 p-3 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <span className="inline-flex items-center gap-1 text-xs font-medium text-white">
            <i className="ri-play-circle-line text-sm"></i>
            查看详情
          </span>
        </div>
      </div>
      <h3 className="mt-2.5 truncate text-sm md:text-[15px] font-medium text-foreground-900 transition-colors group-hover:text-accent-600">
        {item.title}
      </h3>
      <p className="mt-1 truncate text-xs text-foreground-500">
        {item.genres.slice(0, 2).join(" · ")}
        <span className="mx-1.5 text-foreground-300">|</span>
        {item.year}
        {showViews && (
          <>
            <span className="mx-1.5 text-foreground-300">|</span>
            {item.views} 万次播放
          </>
        )}
      </p>
    </Link>
  );
}